export interface AttendeeStatus {
  isWaitlist: boolean;
}

export interface AttendeeStatusSummary {
  total: number;
  confirmedCount: number;
  waitlistedCount: number;
  hasWaitlisted: boolean;
  /** True only when there's at least one attendee AND every one is waitlisted. */
  allWaitlisted: boolean;
  /** True when the group has both confirmed and waitlisted seats. */
  isMixed: boolean;
}

/**
 * Single source of truth for the registration-state summary used by the
 * confirmation page (and anywhere else we need to describe a group's
 * confirmed/waitlist split).
 */
export function summarizeAttendeeStatuses(
  attendees: AttendeeStatus[],
): AttendeeStatusSummary {
  const total = attendees.length;
  const waitlistedCount = attendees.filter((a) => a.isWaitlist).length;
  const confirmedCount = total - waitlistedCount;
  const hasWaitlisted = waitlistedCount > 0;
  const allWaitlisted = total > 0 && waitlistedCount === total;
  const isMixed = hasWaitlisted && !allWaitlisted;

  return {
    total,
    confirmedCount,
    waitlistedCount,
    hasWaitlisted,
    allWaitlisted,
    isMixed,
  };
}
